import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useCountUp(target, t0, t1, trigger) {
  const $ = _c(9);
  const duration = t0 === undefined ? 1700 : t0;
  const delay = t1 === undefined ? 100 : t1;
  const [current, setCurrent] = useState(0);
  let t2;
  if ($[0] !== delay || $[1] !== duration || $[2] !== target) {
    t2 = () => {
      let animationId;
      const startTime = performance.now() + delay;
      const animate = now => {
        const elapsed = now - startTime;
        if (elapsed < 0) {
          animationId = requestAnimationFrame(animate);
          return;
        }
        if (!Number.isFinite(target) || target <= 0) {
          setCurrent(0);
          return;
        }
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        setCurrent(Math.round(target * eased));
        if (progress < 1) {
          animationId = requestAnimationFrame(animate);
        }
      };
      animationId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationId);
    };
    $[0] = delay;
    $[1] = duration;
    $[2] = target;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== delay || $[5] !== duration || $[6] !== target || $[7] !== trigger) {
    t3 = [target, duration, delay, trigger];
    $[4] = delay;
    $[5] = duration;
    $[6] = target;
    $[7] = trigger;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  return current;
}